<template>
  <div>
    <header class="main-content--header">
      <h4>Dashboard</h4>
    </header>
    <section class="main-content--body">
      <div class="wrapper-md">
        <div class="main-content--panel">
          <!--<div class="panel&#45;&#45;header">-->
            <!--<p class="">Share on </p>-->
            <!--<a target="_blank"-->
               <!--class="twitter-share-button m-r-md"-->
               <!--data-size="large"-->
               <!--href="https://twitter.com/intent/tweet?text=Check%20out%20Worklogs.%20A%20tool%20that%20helps%20track%20working%20hours%20for%20members%20in%20remote%20teams.&url=https://worklogs.co&via=useworklogs"-->
            <!--&gt;Twitter</a>-->
            <!--&lt;!&ndash;<a target="_blank"&ndash;&gt;-->
            <!--&lt;!&ndash;href="http://www.facebook.com/sharer.php?u=https://worklogs.co"&ndash;&gt;-->
            <!--&lt;!&ndash;&gt;Facebook</a>&ndash;&gt;-->
            <!--<div class="fb-share-button" data-href="https://worklogs.co" data-layout="button_count" data-size="large" data-mobile-iframe="true"><a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fworklogs.co%2F&amp;src=sdkpreparse">Share</a></div>-->
          <!--</div>-->
          <div class="panel--top">
            <router-view>
            </router-view>
          </div>
          <div class="panel--bottom">
            <div class="activity-header m-t-md">
              <h4 class="has-text-centered">Latest Activity</h4>
            </div>
            <div class="activity-content m-t-md">

              <div v-if="activity">
                <table>
                  <thead>
                  <tr>
                    <th>Duration</th>
                    <th>Reason</th>
                    <th>Date and Time</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in computedActivities">
                    <td>{{item.duration | capitalize}}</td>
                    <td>{{item.reason | capitalize}}</td>
                    <td>{{item.date}}</td>
                  </tr>
                  </tbody>
                </table>
                <router-link to="/activity" class="m-t-md button is-large is-primary is-outlined">
                  View More
                </router-link>
              </div>
              <div v-else>
                <h3>Looks like you've never signed in to your team before.</h3>
                <h3>Let's change that by signing in with the button above</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { store } from '../store/store';
  import axios from 'axios'
  import moment from 'moment'
  import tz from 'moment-timezone'

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken;

  export default {
    name: 'Signin',
    data () {
      return {
        computedActivities: {},
        isSignedin: false,
        activity: false,
        loggedReason: '',
        loggedOutReason: '',
        signInTime: '',
        test: 'this is a test'
      }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    beforeRouteEnter (to, from, next)  {
      axios.get('https://api.kuzcoapp.com/api/v1/log')
        .then ( function(response) {
          let _activities = response.data.data.records
          next(vm => {
            if (Object.keys(_activities).length == 0) {
              vm.activity = false
            }
            else {
              vm.activity = true
            }
            vm.mainActivities = _activities;
            let newActivities = {};
            for( let i in _activities) {
              if (i > 3) break;
              let one = _activities[i]
              let two = _activities[i]
              if (_activities[i].length == 1) {
                let signintime = one[0].created_at;
                let start = moment(signintime);
                let end = moment().format();
                let duration = moment.duration(start.diff(end));
                let _reason = one[0].log_description;
                let _date = signintime;
                let _momentdate = moment(_date).format('MMMM Do YYYY, h:mm:ss a')
                newActivities[i] = {
                  duration: 'Still signed in',
                  date: _momentdate,
                  reason: _reason
                }
                vm.computedActivities = newActivities;
                store.commit ('_lastactivity', newActivities)
              }
              else if (_activities[i].length == 2) {
                let signintime = one[0].created_at;
                let signouttime = two[1].created_at;
                let start = moment(signintime);
                let end = moment(signouttime);
                let duration = moment.duration(start.diff(end));
                let reasonone = one[0].log_description;
                let reasontwo = two[1].log_description;
                let _reason = reasontwo ? reasontwo : reasonone ? reasonone : ''
                let _date = signouttime;
                let _momentdate = moment(_date).format('MMMM Do YYYY, h:mm:ss a')
                newActivities[i] = {
                  duration: duration.humanize(),
                  date: _momentdate,
                  reason: _reason
                }
                vm.computedActivities = newActivities;
                store.commit ('_lastactivity', newActivities)
              }
              else {
              }
            }
          })
        })
        .catch ( function(error) {
          next(false)
          console.log(error);
        });
    },
    watch: {
      $route () {
        let self = this;
        axios.get('https://api.kuzcoapp.com/api/v1/log')
          .then ( function(response) {
            let _activities = response.data.data.records
            if (Object.keys(_activities).length == 0) {
              self.activity = false
            }
            else {
              self.activity = true
            }
            let newActivities = {};
            for (let i in _activities) {
              if (i > 3) break;
              let one = _activities[i]
              let two = _activities[i]
              if (_activities[i].length == 1) {
                let signintime = one[0].created_at;
                let start = moment(signintime);
                let end = moment().format();
                let duration = moment.duration(start.diff(end));
                let _reason = one[0].log_description;
                let _momentdate = moment(_date).format('MMMM Do YYYY, h:mm:ss a')
                newActivities[i] = {
                  duration: 'Still signed in',
                  date: _momentdate,
                  reason: _reason
                }
                self.computedActivities = newActivities;
                store.commit ('_lastactivity', newActivities)
              }
              else if (_activities[i].length == 2) {
                let signintime = one[0].created_at;
                let signouttime = two[1].created_at;
                let start = moment(signintime);
                let end = moment(signouttime);
                let duration = moment.duration(start.diff(end));
                let reasonone = one[0].log_description;
                let reasontwo = two[1].log_description;
                let _reason = reasontwo ? reasontwo : reasonone ? reasonone : ''
                let _date = signouttime;
                newActivities[i] = {
                  duration: duration.humanize(),
                  date: moment(_date).format('MMMM Do YYYY, h:mm:ss a'),
                  reason: _reason
                }
                self.computedActivities = newActivities;
                store.commit ('_lastactivity', newActivities)
              }
            }
          })
          .catch ( function(error) {
            console.log(error);
          });
      }
    },
    computed: {
      signedin () {
        return store.state.signedin;
      },
      lastactivity () {
        return store.state.lastactivity;
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .button.is-large {
    font-size: 2.5rem;
  }
  .panel--header {
    p, a, .fb-share-button {
      display: inline-block;
    }
  }
  .panel--top {
    margin-top: 80px;
    margin-bottom: 50px;
    text-align: center;
    font-family: "Proxima SemiBold";
    h3 {
      font-size: 17px;
    }
  }
  .panel--bottom {
    margin-top: 50px;
    margin-bottom: 60px;
    padding: 30px;
    .activity-header {
      border-top: 1px solid #D7E2E9;
      /*border-bottom: 1px solid #D7E2E9; */
      padding: 10px 0;
      h4 {
        font-size: 14px;
      }
    }
    .activity-content {
      text-align: center;
      font-size: 13px;
    }
  }
  .centered {
    margin: 0 auto;
    display: table;
  }
  form {
    max-width: 100%;
    width: 600px;
    margin: auto;
    text-align: center;
    label {
      font-size: 16px;
    }
    .form-control {
      height: 40px;
      font-size: 14px;
    }
  }
  .status {
    border-radius: 100%;
    width: 8px;
    height: 8px;
    border-width: 4px;
    color: $kuzcogreen;
    border-style: solid;
    display: inline-block;
  }
  table {
    font-size: 14px;
    border: 1px solid #d7e2e9;
  }
  th {
    padding: 15px;
    border-bottom: 1px solid #D7E2E9;
  }
  tr {
    cursor: pointer;
  }
  td {
    padding: 15px;
    border-top: 1px solid #D7E2E9;
  }
  .slack-loader {
    margin: -4px auto;
    display: inline-block;
    font-size: 4px;
    text-indent: -9999em;
    width: 4em;
    height: 4em;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .slack-loader:before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .slack-loader:after {
    background: $kuzcogreen;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// DashboardHome.vue?49901bc4